import React, { useState } from 'react';
import Image from 'next/image';
import PropTypes from 'prop-types';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import DynamicInjectOfferDetails from '@tcp/core/src/components/common/organisms/OfferDetails/container/DynamicInjectOfferDetails.js';
import PromoMessage from '@tcp/core/src/components/common/organisms/Promotions/atoms/PromoMessage';
import { getLabelFromCopyOrFromTranslation } from '@tcp/core/src/utils/labels/labelUtilty';
import globalCartItemTileLabels from '@tcp/core/src/utils/labels/globalCartItemTile.labels';
import PromotionContainer from './styles/Promotion.style';
import { getIconAsPerBrand } from '../../../../../utils/utils';
import OfferDetails from '../../../../common/organisms/OfferDetails';
import { createPromoArray } from '../../../../../utils';

// Promotion component rendered on PLP pages.
// eslint-disable-next-line sonarjs/cognitive-complexity
function PromotionView(props) {
  const bestOfferLabel = getLabelFromCopyOrFromTranslation(
    'global.cartItemTile.lbl_best_offer',
    globalCartItemTileLabels
  );
  const {
    showHeading,
    className,
    isBuyMorePromoEnabled,
    serverTime,
    promotionsData,
    pageName,
    brand,
    trackClickPromotion,
    isTileRedesignAB,
    TCPPromotionPrice,
    TCPPromotionID,
    isUpdatedPromotionsDisplayEnabled,
    fromStoreSpecialsCarousel,
    isPickupSelectedAtProductDetail,
    TCPPromotionPriceStoreSpecial,
    storeSpecials,
    fromStoreSpecialCaraosal,
  } = props;

  const [isOfferDetailsModalActive, setOfferDetailsModalActive] = useState(false);
  const [clickedMessage, setClickedMessage] = useState(null);

  const getMarginTopClass = (index, headingVisible) =>
    index > 0 || headingVisible ? 'promo-list-item-margin-top' : '';
  const getUnderLineClass = (isUnderLine) => (isUnderLine === 'true' ? 'underLine' : null);

  let promo = null;
  try {
    if (promotionsData[TCPPromotionID]) {
      promo = createPromoArray({
        promotionsData,
        serverTime,
        TCPPromotionPrice,
        TCPPromotionID,
        isUpdatedPromotionsDisplayEnabled,
        isPickupSelectedAtProductDetail,
        TCPPromotionPriceStoreSpecial,
        storeSpecials,
        fromStoreSpecialCaraosal,
      });
    }
  } catch (e) {
    console.log(e);
  }

  const openOfferDetails = async (message) => {
    setClickedMessage(message);
    await DynamicInjectOfferDetails();
    setOfferDetailsModalActive(true);
    trackClickPromotion({
      promotion_cd55: pageName,
      promotion_metrics17: 1,
      promotion_cd56: message.promotionMessage,
    });
  };

  function promotionPlacement(promoPlacementAB, message, index) {
    return !promoPlacementAB
      ? index <= 1 && message?.promotionMessage && (
          <div className={`promo-list-item ${getMarginTopClass(index, showHeading)}`}>
            <div>
              <BodyCopy
                onClick={() => openOfferDetails(message)}
                anchorVariation="primary"
                fontSizeVariation="medium"
                className={`promo_message_anchor ${getUnderLineClass(message?.clickable)}`}
              >
                <PromoMessage message={message} isPlp />
              </BodyCopy>
            </div>
          </div>
        )
      : index <= 1 && message?.promotionMessage && (
          <div>
            <BodyCopy
              onClick={() => openOfferDetails(message)}
              anchorVariation="primary"
              fontSizeVariation="medium"
              className={'promo-ab'}
            >
              <PromoMessage message={message} isPlp />
            </BodyCopy>
          </div>
        );
  }

  return (
    <>
      {isOfferDetailsModalActive && (
        <OfferDetails
          isOfferDetailsModalActive
          setOfferDetailsModalActive={setOfferDetailsModalActive}
          promo={clickedMessage}
          brand={brand}
        />
      )}
      {isBuyMorePromoEnabled && promo?.length ? (
        <PromotionContainer
          className={className}
          isTileRedesignAB={isTileRedesignAB}
          fromStoreSpecialsCarousel={fromStoreSpecialsCarousel}
        >
          {showHeading && !isTileRedesignAB && (
            <div className={`promotion-header ${className}`}>
              <div className="icon">
                <Image src={getIconAsPerBrand()} width={22} height={18} alt="Special-Offers-Icon" />
              </div>
              <div className="best-offers">{bestOfferLabel}</div>
            </div>
          )}
          {promo.map((message, index) => {
            return promotionPlacement(isTileRedesignAB, message, index);
          })}
        </PromotionContainer>
      ) : null}
    </>
  );
}
PromotionView.propTypes = {
  className: PropTypes.string,
  showIcon: PropTypes.bool,
  showHeading: PropTypes.bool,
  isBuyMorePromoEnabled: PropTypes.bool,
  serverTime: PropTypes.number,
  promotionsData: PropTypes.shape({}),
  trackClickPromotion: PropTypes.func,
  pageName: PropTypes.string,
  brand: PropTypes.string,
  isTileRedesignAB: PropTypes.bool,
};
PromotionView.defaultProps = {
  className: 'isPLP',
  showIcon: true,
  showHeading: false,
  isBuyMorePromoEnabled: false,
  serverTime: null,
  promotionsData: {},
  trackClickPromotion: () => {},
  pageName: 'PLP',
  brand: '',
  isTileRedesignAB: false,
};
export default PromotionView;
